import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#6C63FF',
        secondary: '#2D2B55',
        accent: '#A78BFA',
        error: '#EF4444',
        info: '#38BDF8',
        success: '#34D399',
        warning: '#FBBF24',
        background: '#1A1A2E',
        surface: '#16213E',
      },
    },
  },
});
